import React from 'react';
import { Select } from 'antd';
import { TIME_FORMAT } from '../../../../constants';
import { useStore } from '../../../../store/rootStore';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { getDirection } from '../../../../helpers';
import s from './TimeFormatSelect.module.scss';
const { Option } = Select;
const TimeFormatSelect = () => {
    const { timeFormat, setTimeFormat } = useStore();
    const { t } = useTranslation();
    const handleChange = (value) => {
        setTimeFormat(value);
    };
    return (React.createElement(Select, { className: s.select, defaultValue: TIME_FORMAT.TWELVE_HOURS, value: timeFormat, onChange: handleChange, direction: getDirection() === 'rtl' ? 'rtl' : 'ltr', popupClassName: s.dropdown, size: "small" },
        React.createElement(Option, { value: TIME_FORMAT.TWELVE_HOURS }, t('twelveHours')),
        React.createElement(Option, { value: TIME_FORMAT.TWENTY_FOUR_HOURS }, t('twentyFourHours'))));
};
export default observer(TimeFormatSelect);
